import { render, staticRenderFns } from "./StatisticTop.vue?vue&type=template&id=07fc6529&scoped=true&"
import script from "./StatisticTop.vue?vue&type=script&lang=ts&"
export * from "./StatisticTop.vue?vue&type=script&lang=ts&"
import style0 from "./StatisticTop.vue?vue&type=style&index=0&id=07fc6529&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07fc6529",
  null
  
)

export default component.exports